export default {
  this_table_does_not_have_a_bill_yet: "Cette table n'a pas encore de facture",
  please_check_with_the_staff: "Veuillez vérifier auprès du personnel",
};
